<template>
  <div class="bgImg">
    <div class="title">
      <div class="titleLeft"></div>
      <slot name="titleRight"></slot>
    </div>
    <div class="content">
      <slot name="content"></slot>
    </div>
    <div class="footer">Copyright © 2018研学招聘 <a href="
https://beian.miit.gov.cn" target="_blank">京ICP备2020033869号-1</a>    |  <a href="/shenming" target="_blank">法律声明</a>  |  <a href="/yinsi" target="_blank">隐私政策</a>  |  <a href="/help" target="_blank">帮助中心</a></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    methods:{}
  }
</script>

<style scoped lang="scss">
  .bgImg {
    min-width: 1200px;
    overflow: hidden;
    height: 100%;
    background: url("../assets/img/bgImgLogin.png") no-repeat center;
    background-size: 100% 100%;
    .title {
      width: 1200px;
      height: 56px;
      margin: 38px auto 38px auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .titleLeft {
        width: 97px;
        height: 56px;
        //background: url("../assets/img/logo.png") no-repeat center;
        //background-size: cover;
      }
    }
    .content {
      position: absolute;
      top: 100px;
      /* left: 50%; */
      bottom: 100px;
      width: 100%;
      overflow-y: scroll;
      /*width: 1200px;*/
      /*margin: 0 auto;*/
      display: flex;
      justify-content: center;
      align-items: self-start;
    }
    .footer {
      width: 100%;
      color: #999999;
      font-size: 16px;
      text-align: center;
      position: absolute;
      bottom: 51px;
      left: 0;
      a{
        color: #999999;
      }
      .btn1 {
        cursor: pointer;
      }
    }
  }
</style>
